export default __webpack_public_path__ + "static/media/Error.450e7f11.jpg";